import { render, staticRenderFns } from "./sustainability-banner-cmp.vue?vue&type=template&id=1bdf7294&scoped=true"
import script from "./sustainability-banner-cmp.vue?vue&type=script&lang=js"
export * from "./sustainability-banner-cmp.vue?vue&type=script&lang=js"
import style0 from "./sustainability-banner-cmp.vue?vue&type=style&index=0&id=1bdf7294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdf7294",
  null
  
)

export default component.exports